export default "__VITE_ASSET__DOFhqsEy__"